import React from "react";

import { SystemEditGuard } from "~/systems/feature/system-edit-guard";
import type { SystemHomeTabElements } from "~/systems/feature/system-home-tab-routes";

const SystemHomeBranchesPage = React.lazy(() => import("./system-home-branches"));
const SystemHomeChangeRequestDetailPage = React.lazy(() => import("./system-home-change-request-detail"));
const SystemHomeChangeRequestsPage = React.lazy(() => import("./system-home-change-requests"));
const SystemHomeCommitsPage = React.lazy(() => import("./system-home-commits"));
const SystemHomeChangesAvailablePage = React.lazy(() => import("./system-home-changes-available"));
const SystemHomeCommitDetailPage = React.lazy(() => import("./system-home-commit-detail"));
const SystemHomeCreateChangeRequestPage = React.lazy(() => import("./system-home-create-change-request"));
const SystemHomeDirectoryPage = React.lazy(() => import("./system-home-directory"));
const SystemHomeIndexPage = React.lazy(() => import("./system-home-index"));
const SystemHomeSettingsPage = React.lazy(() => import("./system-home-settings"));
const SystemHomeWorkflowsPage = React.lazy(() => import("./system-home-workflows"));

export const systemHomeTabElements: SystemHomeTabElements = {
  index: <SystemHomeIndexPage />,
  directory: <SystemHomeDirectoryPage />,
  workflows: <SystemHomeWorkflowsPage />,
  branches: <SystemHomeBranchesPage />,
  settings: <SystemHomeSettingsPage />,
  commits: <SystemHomeCommitsPage />,
  changesAvailable: <SystemHomeChangesAvailablePage />,
  commitDetail: <SystemHomeCommitDetailPage />,
  changeRequests: <SystemHomeChangeRequestsPage />,
  changeRequestDetail: <SystemHomeChangeRequestDetailPage />,
  createChangeRequest: (
    <SystemEditGuard message="You need edit access to create a change request.">
      <SystemHomeCreateChangeRequestPage />
    </SystemEditGuard>
  ),
};
